import { ChevronDown, ChevronUp } from "lucide-react";

/** Reordena un ítem en un array inmutable. */
export function moveListItem(list, idx, dir) {
  const target = idx + dir;
  if (!Array.isArray(list) || target < 0 || target >= list.length) return list;
  const next = [...list];
  const [row] = next.splice(idx, 1);
  next.splice(target, 0, row);
  return next;
}

/** Botones subir/bajar para listas del CMS. */
export function MoveButtons({ idx, total, onMove, className = "" }) {
  return (
    <div className={`flex flex-col gap-0.5 ${className}`}>
      <button
        type="button"
        aria-label="Subir"
        disabled={idx === 0}
        onClick={() => onMove(-1)}
        className="p-1 rounded-md text-brand-dark/50 hover:bg-[#f8faf9] disabled:opacity-30"
      >
        <ChevronUp size={16} />
      </button>
      <button
        type="button"
        aria-label="Bajar"
        disabled={idx >= total - 1}
        onClick={() => onMove(1)}
        className="p-1 rounded-md text-brand-dark/50 hover:bg-[#f8faf9] disabled:opacity-30"
      >
        <ChevronDown size={16} />
      </button>
    </div>
  );
}
